/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_ADJUSTMENT_REASON_CODE,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_ADJUSTMENT_REASON_CODE,
  isLoading: value,
});

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_ADJUTMENT_BY_REASON_CODE,
  payload: value,
});
// //set Initial value of store
export const refreshAdjustmentCodeByReason = () => ({
  type: ActionTypes.REFRESH_ADJUSTMENY_CODE_REASON,
  payload: {},
});
export const refreshReduxAdjustmentByReasonDetailScreen = () => ({
  type:  ActionTypes.SET_REFRESH_DATA_REDUX_DETAIL_SCREEN,
  payload: {},
});
// API call to get plan types for radio list
export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {});
};

export const dispatchRebatePrograme = (data) => ({
  type: ActionTypes.GET_REBATE_PROGRAM_ADJUSTMENT_REASON_CODE,
  payload: data,
});

// API call for the All Adjustment Grid
export const getAllAdjustmentGrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.ALL_ADJUSTMENT_GRID}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_ALL_ADJUSTMENT_GRID,
        allAdjustmentGrid: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setAdjustmentReasonCodeGrid = (data) => ({
  type: ActionTypes.GET_ADJUSTMENT_REASON_CODE_SEARCH_RESULT,
  searchResult: data,
});

// API call for the All Adjustment Grid
export const getAdjustmentReasonCodeResultGrid =
  (values, fromDisplay = false) =>
  (dispatch) => {
    dispatch(setLoading(true));

    return axios
      .post(`${serviceEndPoint.ADJUSTMENT_REASON_CODE_SEARCH_RESULT}`, values)
      .then((response) => {
        dispatch(setLoading(false));
        if (response.data?.adjustmentByReasonCodeReportVO.length === 0) {
          if (!fromDisplay) dispatch(showNoDataMessage());
          else dispatch(setAdjustmentReasonCodeGrid([]));
        } else {
          return dispatch(
            setAdjustmentReasonCodeGrid(
              response.data?.adjustmentByReasonCodeReportVO
            )
          );
        }
      })
      .catch((response) => {
        dispatch(setLoading(false));
        dispatch([]);
        return response;
      });
  };

export const setAdjustmentByReasonCodeExportAll = (data, drugActivityType) => ({
  type: ActionTypes.SET_EXPORT_ALL_PDF_ADJUSTMENT_REASON_CODE,
  payload: { data, drugActivityType },
});

export const reportData = (values, drugActivityType) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.ADJUSTMENT_REASON_CODE_SEARCH_RESULT, values)
    .then((response) => {
      dispatch(
        setAdjustmentByReasonCodeExportAll(
          response?.data?.adjustmentByReasonCodeReportVO,
          drugActivityType
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(
        setAdjustmentByReasonCodeExportAll([], values.drugActivityTypeCd)
      );
    });
};

export const getAdjustmentByReasonCodeExportAll =
  ({ rebateProgramCd, beginDate, endDate, drugActivityTypeCd, mfgTypeCd }) =>
  (dispatch) => {
    const drugActivityValue = {
      R: ['URAC', 'URCA', 'URAL'],
      W: ['WOFF', 'DBAL', 'FRGV'],
      I: ['IOAR', 'IDBL'],
      X: ['ICLC', 'IDBU'],
      U: ['UACD', 'UACM', 'UAAR', 'UCCN', 'UOCR', 'UOMR'],
      T: ['DBUP'],
    };
    for (let i = 0; i < drugActivityTypeCd.length; i += 1) {
      const values = {
        rebateProgramCd,
        beginDate,
        endDate,
        mfgTypeCd,
        drugActivityTypeCd: drugActivityValue[drugActivityTypeCd[i].codeValue],
      };

      dispatch(reportData(values, drugActivityTypeCd[i].codeValue));
    }
  };
